module.exports = __webpack_public_path__ + "img/Profile Icon - white.500a4572.svg";